import { render, staticRenderFns } from "./gc-header-toolbar.vue?vue&type=template&id=2ef7ecb3"
import script from "./gc-header-toolbar.vue?vue&type=script&lang=js"
export * from "./gc-header-toolbar.vue?vue&type=script&lang=js"
import style0 from "./gc-header-toolbar.vue?vue&type=style&index=0&id=2ef7ecb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports